import { COMPANY, IMAGES, MAPS_EMBED_URL } from "../../data/content";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const MapSection = () => (
  <section
    data-testid="map-section"
    className="py-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 border-b border-neutral-800"
  >
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
      <div className="lg:col-span-5">
        <img
          data-testid="logo-sede"
          src={IMAGES.logoSede}
          alt="Logo storico Legend Team — sede e amministrazione"
          className="h-16 w-auto mb-5"
          loading="lazy"
        />
        <span className="mono-label text-xs text-red-500 font-bold uppercase">
          Sede & Amministrazione
        </span>
        <h3 className="font-display text-2xl font-bold uppercase text-white mt-1 mb-2">
          Sant'Agata Feltria
        </h3>
        <p data-testid="legal-address" className="text-sm text-neutral-300">
          {COMPANY.ragioneSociale}
          <br />
          Strada Perticara, 13 &bull; 47866 Sant'Agata Feltria (Rimini)
        </p>
        <p data-testid="legal-piva" className="mono-label text-xs text-neutral-400 mt-2">
          P.IVA {COMPANY.piva} &bull;{" "}
          <a href={`mailto:${COMPANY.email}`} data-testid="legal-email" className="text-red-500 hover:text-red-400">
            {COMPANY.email}
          </a>{" "}
          &bull;{" "}
          <a href={COMPANY.website} data-testid="legal-website" className="text-red-500 hover:text-red-400">
            {COMPANY.websiteLabel}
          </a>
        </p>
        <a
          data-testid="whatsapp-link"
          href={COMPANY.whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Scrivi su WhatsApp alla segreteria Legend Team"
          className="mt-5 inline-flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5b] text-black px-4 py-2.5 transition-colors"
        >
          <WhatsAppIcon className="w-5 h-5" />
          <span className="text-left leading-tight">
            <span className="block mono-label text-[10px] uppercase tracking-wider">Segreteria WhatsApp</span>
            <span className="block text-sm font-black">{COMPANY.whatsapp}</span>
          </span>
        </a>
        <br />
        <a
          data-testid="directions-link"
          href="https://www.google.com/maps/search/?api=1&query=legend+team+srl+sant'agata+feltria"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-4 text-xs uppercase tracking-widest font-bold text-red-500 hover:text-red-400"
        >
          Apri le indicazioni stradali &rarr;
        </a>
      </div>
      <div className="lg:col-span-7">
        <div className="aspect-[21/9] border border-neutral-800 overflow-hidden">
          <iframe
            data-testid="map-iframe"
            title="Google Maps — Legend Team Srl, Sant'Agata Feltria"
            src={MAPS_EMBED_URL}
            className="w-full h-full grayscale-[0.4] contrast-[1.05]"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  </section>
);
